import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map, Observable, of, switchMap, tap, throwError } from 'rxjs';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { UserService } from 'app/core/user/user.service';
import { environment } from 'environment/environment';
import { User } from '../user/user.types';
import { Router } from '@angular/router';

@Injectable()
export class AuthService {
    private _authenticated: boolean = false;
    private _checkUrl: boolean = false;
    private hasAccess: boolean = false;
    
    private _IsLogin: boolean = false;
    private apiUrl = environment.baseUrl;
    private apiUserId = environment.createdby;
    public NoRestrictions = false;
    user: User;
    /**
     * Constructor
     */
    constructor(
        private _httpClient: HttpClient,
        private _userService: UserService,
        private _router: Router,
    ) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for access token
     */
    set accessToken(token: string) {
        localStorage.setItem('accessToken', token);
    }

    get accessToken(): string {
        return localStorage.getItem('accessToken') ?? '';
    }

    set accessUser(user: any) {
        localStorage.setItem('user', user);
    }

    get accessUser(): any {
        return localStorage.getItem('user') ?? '';
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Forgot password
     *
     * @param email
     */
    forgotPassword(email: string): Observable<any> {
        return this._httpClient.post(
            this.apiUrl + 'Forgotpassword/PostForgotPassword/',
            email
        );
    }

    /**
     * Reset password
     *
     * @param password
     */
    resetPassword(password: string): Observable<any> {
        return this._httpClient.post('api/auth/reset-password', password);
    }
 resetPartnerPassword(obj: any): Observable<any> {
        return this._httpClient.post(this.apiUrl +'Partner/ResetPassword', obj);
    }
     getDecryptid(id : any): Observable<any> {
    //debugger;
    return this._httpClient.get<any>(this.apiUrl + 'EncryptDecrypt/Decrypt/' + id);
  }
    /**
     * Sign in
     *
     * @param credentials
     */
    signIn(
        credentials: { Email: string; Password: string; IpAddress: string },
        ipId
    ): Observable<any> {
        // ;
        //console.log('api call');
        // Throw error, if the user is already logged in
        if (this._authenticated) {
            return throwError('User is already logged in.');
        }

        credentials.IpAddress = ipId;

        // return this._httpClient.post('api/auth/sign-in', credentials).pipe(
        //     switchMap((response: any) => {

        //         // Store the access token in the local storage
        //         this.accessToken = response.accessToken;

        //         // Set the authenticated flag to true
        //         this._authenticated = true;

        //         // Store the user on the user service
        //         this._userService.user = response.user;

        //         // Return a new observable with the response
        //         return of(response);
        //     })
        // );

        //console.log(credentials);

        return this._httpClient
            .post(this.apiUrl + 'UserLogin/Login', credentials)
            .pipe(
                switchMap((response: any) => {
                    //debugger;
                    //console.log('response', response.email);

                    // Store the access token in the local storage
                    this.accessToken = response.strToken;

                    //this.accessUser = JSON.stringify(response);

                    //             id: number;
                    // name?: string;
                    // userName: string;
                    // email: string;
                    // roles?: [];
                    // avatar?: string;
                    // status?: string;

                    // Set the authenticated flag to true
                    if (response.strResult == 'Success') {
                        this._authenticated = true;
                        this._IsLogin = true;
                        let res = {
                            id: response.intUserId,
                            email: response.strUsername,
                            userName: response.strUsername,
                            avatar: './assets/images/avatars/brian-hughes.jpg',
                            partner_id: response.partner_id,
                            externaluser_indicator:
                                response.externaluser_indicator,
                            company_id: response.company_id,
                            partnerName: response.partnerName,
                            profile_image_name: response.profile_image_name,
                            profile_image_patner: response.profile_image_patner,
                            urllist: response.urllist,
                            role_id: response.role_id,
                            user_PartnerName:response.user_PartnerName,
                            first_login_indicator:response.first_login_indicator
                        };

                        //alert(JSON.stringify(res));
                        //console.log(res);

                        this.accessUser = JSON.stringify(res);

                        // alert(this.accessUser);

                        // Store the user on the user service

                        this._userService.user = res;

                        //console.log('response for user', this._userService.user);
                        this.apiUserId = res.id;
                        //this.user.id = this.user.id
                    } else {
                        this._authenticated = false;
                        let res = {
                            id: response.intUserId,
                            email: response.strUsername,
                            userName: response.strUsername,
                            avatar: './assets/images/avatars/brian-hughes.jpg',
                            partner_id: response.partner_id,
                            externaluser_indicator:
                                response.externaluser_indicator,
                            company_id: response.company_id,
                            partnerName: response.partnerName,
                            profile_image_name: response.profile_image_name,
                            profile_image_patner: response.profile_image_patner,
                            urllist: response.urllist,
                            role_id: response.role_id,
                             first_login_indicator:response.first_login_indicator
                        };
                        this.accessUser = JSON.stringify(res);
                        // Store the user on the user service
                        this._userService.user = res;
                    }

                    //this._userService.user.avatar = './assets/images/avatars/brian-hughes.jpg';

                    // Return a new observable with the response
                    return of(response);
                })
            );
    }

    public getIPAddress() {
        return this._httpClient.get('https://api.ipify.org?format=json');
    }
    public getUserLocation(): Observable<string> {
        const cached = localStorage.getItem('userLocation');
        if (cached!=="Unknown" && cached) {
            return of(cached); 
        }

        return this._httpClient.get<any>("https://ipapi.co/json/").pipe(
            map(data => `${data.city}, ${data.region}, ${data.country_name}`),
            tap(fullLocation => {
                localStorage.setItem('userLocation', fullLocation);
            }),
            
        );
    }

        

      
  

    /**
     * Sign in using the access token
     */
    signInUsingToken(): Observable<any> {
        // Sign in using the token
        return this._httpClient
            .post('api/auth/sign-in-with-token', {
                accessToken: this.accessToken,
            })
            .pipe(
                catchError(() =>
                    // Return false
                    of(false)
                ),
                switchMap((response: any) => {
                    // Replace the access token with the new one if it's available on
                    // the response object.
                    //
                    // This is an added optional step for better security. Once you sign
                    // in using the token, you should generate a new one on the server
                    // side and attach it to the response object. Then the following
                    // piece of code can replace the token with the refreshed one.
                  
                    if (response.accessToken) {
                        this.accessToken = response.accessToken;
                    }

                    // Set the authenticated flag to true
                    this._authenticated = true;

                    // Store the user on the user service
                    this._userService.user = response.user;

                   
                    // Return true
                    return of(true);
                })
            );
    }

    /**
     * Sign out
     */
    signOut(): Observable<any> {
        // Remove the access token from the local storage
        localStorage.removeItem('accessToken');

        // Set the authenticated flag to false
        this._authenticated = false;

        // Return the observable
        return of(true);
    }

    /**
     * Sign up
     *
     * @param user
     */
    signUp(user: {
        name: string;
        email: string;
        password: string;
        company: string;
    }): Observable<any> {
        return this._httpClient.post('api/auth/sign-up', user);
    }

    /**
     * Unlock session
     *
     * @param credentials
     */
    unlockSession(credentials: {
        email: string;
        password: string;
    }): Observable<any> {
        return this._httpClient.post('api/auth/unlock-session', credentials);
    }

    /**
     * Check the authentication status
     */
    check(): Observable<boolean> {
        debugger;
        const userString=localStorage.getItem('user')
        const user = userString ? JSON.parse(userString) : null;
   

        // Check if the user is logged in
        if (this._authenticated) {
                 const path=window.location.pathname;
                     if(user.first_login_indicator==0&&(user.role_id==4 || user.role_id == 9))
      {
                 if(path!="/reset-password/partner"&&path!="/sign-in"){

           
         this.signOut();
         return of(false);
         

      }
    }
   
            return of(true);
        }

        // Check the access token availability
        if (!this.accessToken) {
            return of(false);
        }

        // Check the access token expire date
        if (AuthUtils.isTokenExpired(this.accessToken)) {
            return of(false);
        }

        // if (this.isCheckURL()) {
        //     return of(false);
        // }
    


        // If the access token exists and it didn't expire, sign in using it
        return this.signInUsingToken();
    }

    isAuthenticatedUser(): boolean {
        return this._authenticated;
      }

    // isCheckURL(): boolean{
    //     debugger;
    //     const currentURLValue = window.location.pathname;

    //     this._authenticated = false;
    //     //this._checkUrl == true;

    //     this.user = JSON.parse(this.accessUser);

    //     //alert(currentURLValue);

    //     this.user.urllist.forEach((menuurl: any) => {
    //         if (this._checkUrl == false)
    //             menuurl.menu_url == currentURLValue ? this._checkUrl = true : this._checkUrl = false;
    //     });

    //     if (currentURLValue == "/norights/norights"){
    //         this._checkUrl = true ;
    //     }

    //     //alert('this._authenticated Value ::--> ' + this._checkUrl);
       
    //     if (this._checkUrl == false) {
    //         //this._authenticated = false;
    //         this.NoRestrictions=true;
    //         return false;
    //     }

    //     return true;
    // }


      //New


    // isCheckURL(): boolean {
    //     debugger;
        
    //     let currentURLValue = "";
    //     currentURLValue = window.location.pathname;
    //     if(currentURLValue == "/sign-in"){
    //         currentURLValue = '/dashboards/customer'; 
    //     }
    //     console.log(`Current URL: ${currentURLValue}`);
    //     const mainURLValue = currentURLValue.split('/')[1]; // Extract the main URL part
    //     console.log(`Main URL part: ${mainURLValue}`);
    
    //     this._authenticated = false;
    //     this._checkUrl = false;  // Initialize _checkUrl to false
    
    //     this.user = JSON.parse(this.accessUser);
    
    //     // Check if the main URL part is in the user's URL list
    //     this.user.urllist.forEach((menuurl: any) => {
    //         const menuMainURL = menuurl.menu_url.split('/')[1]; // Extract the main URL part of menu_url
    //         console.log(`Checking against URL: ${menuMainURL}`);
    //         if (menuMainURL === mainURLValue) {
    //             this._checkUrl = true;
    //             console.log(`Match found: ${menuMainURL}`);
    //         }
    //     });
    
    //     // Special case for the /norights/norights URL
    //     if (currentURLValue === "/norights/norights") {
    //         this._checkUrl = true;
           
    //     }
    
    //     if (!this._checkUrl) {
    //         this.NoRestrictions = true;
    //         console.warn('No matching URL found. Access denied.');
    //         return false;
    //     }
    
    //     console.log('Access granted.');
    //     return true;
    // }
    
    isCheckURL(): boolean {
        ;
        
        let currentURLValue = "";
       
        currentURLValue = window.location.pathname;
        const mainURLValue = currentURLValue.split('/')[1]; 
        

        if(mainURLValue == "auto-login"){
            currentURLValue = '/quotation/add'; 
           }

        if(currentURLValue == "/change-password"){
            this._checkUrl = true;
        }
        if(currentURLValue == "/"){
            this._checkUrl = true;
        }
        else{
           if(currentURLValue == "/sign-in"){
            currentURLValue = '/dashboards/customer'; 
           }

        console.log(`Current URL: ${currentURLValue}`);
        const mainURLValue = currentURLValue.split('/')[1]; // Extract the main URL part
        console.log(`Main URL part: ${mainURLValue}`);
    
        this._authenticated = false;
        this._checkUrl = false;  // Initialize _checkUrl to false
    
        this.user = JSON.parse(this.accessUser);
    
        // Check if the main URL part is in the user's URL list
        this.user.urllist.forEach((menuurl: any) => {
            const menuMainURL = menuurl.menu_url.split('/')[1]; // Extract the main URL part of menu_url
            console.log(`Checking against URL: ${menuMainURL}`);
            debugger;
//            if(menuMainURL=="SalesAgent"){
//  this._checkUrl = true;
//            }
//            else 
            if (menuMainURL === mainURLValue) {
                this._checkUrl = true;
                console.log(`Match found: ${menuMainURL}`);
            }
        });

        // Special case for the /norights/norights URL
        if (currentURLValue === "/norights/norights") {
            this._checkUrl = true;
           
        }
    
        if (!this._checkUrl) {
            this.NoRestrictions = true;
            console.warn('No matching URL found. Access denied.');
            return false;
        }
    
        console.log('Access granted.');

        }
        
        return true;
    }

    Autologin(urlid: String): Observable<any> {
        ;
        
       
      
             
                return this._httpClient
            .get(this.apiUrl + 'UserLogin/AutoLogin/'+ urlid)
            .pipe(
                switchMap((response: any) => {
                  
                    this.accessToken = response.strToken;

                    if (response.strResult == 'Success') {
                        this._authenticated = true;
                        this._IsLogin = true;
                        let res = {
                            id: response.intUserId,
                            email: response.strUsername,
                            userName: response.strUsername,
                            avatar: './assets/images/avatars/brian-hughes.jpg',
                            partner_id: response.partner_id,
                            externaluser_indicator:
                                response.externaluser_indicator,
                            company_id: response.company_id,
                            partnerName: response.partnerName,
                            profile_image_name: response.profile_image_name,
                            profile_image_patner: response.profile_image_patner,
                            urllist: response.urllist,
                            role_id: response.role_id,
                        };

                     
                        this.accessUser = JSON.stringify(res);

                    

                        this._userService.user = res;

                      
                        this.apiUserId = res.id;
                     
                    } else {
                        this._authenticated = false;
                        let res = {
                            id: response.intUserId,
                            email: response.strUsername,
                            userName: response.strUsername,
                            avatar: './assets/images/avatars/brian-hughes.jpg',
                            partner_id: response.partner_id,
                            externaluser_indicator:
                                response.externaluser_indicator,
                            company_id: response.company_id,
                            partnerName: response.partnerName,
                            profile_image_name: response.profile_image_name,
                            profile_image_patner: response.profile_image_patner,
                            urllist: response.urllist,
                            role_id: response.role_id,
                        };
                        this.accessUser = JSON.stringify(res);
                      
                        this._userService.user = res;
                    }

                  
                    return of(response);
                })
            );

        // return this._httpClient
        //     .get(this.apiUrl + 'UserLogin/ThridpartyAutoLogin/'+Id)
        //     .pipe(
        //         switchMap((response: any) => {
    }
    
}
